import { Text } from '@/components/ui/text';
import { cn } from '@/lib/utils';
import { Platform, Pressable } from 'react-native';

interface TopBarNavLinkProps {
  label: string;
  isActive: boolean;
  onPress: () => void;
}

export function TopBarNavLink({ label, isActive, onPress }: TopBarNavLinkProps) {
  return (
    <Pressable
      onPress={onPress}
      style={{
        height: '100%',
        justifyContent: 'center',
        paddingHorizontal: 16,
        borderBottomWidth: isActive ? 3 : 0,
        borderBottomColor: isActive ? '#9ACD32' : 'transparent',
        ...(Platform.OS === 'web' ? { cursor: 'pointer' } : {}),
      }}
    >
      <Text
        className={cn(
          isActive ? 'text-foreground font-bold' : 'text-muted-foreground font-normal',
        )}
        style={{
          fontSize: 16,
          fontWeight: isActive ? '500' : '400',
        }}
      >
        {label}
      </Text>
    </Pressable>
  );
}
